<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <h1>Profile Settings</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">
        <div class="card" id="users-add">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
              <el-tab-pane label="Profile" name="profile">
                <form
                  @submit.prevent="handleProfileSubmission()"
                  method="POST"
                  novalidate
                  data-vv-scope="profile"
                >
                  <div>
                    <div class="form-row">
                      <div class="form-group required col-md-6">
                        <label for="username" class="control-label">Username</label>
                        <input
                          autocomplete="off"
                          type="text"
                          id="username"
                          name="username"
                          v-model="profile.username"
                          v-validate="'required'"
                          :class="{ 'has-error': errors.has('username') }"
                          class="form-control"
                          placeholder="Username"
                          disabled
                        />
                        <div class="help text-danger" v-show="errors.has('username')">
                          {{ errors.first("username") }}
                        </div>
                      </div>
                      <div class="form-group required col-md-6">
                        <label for="name" class="control-label">Name</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          v-model.trim="profile.name"
                          class="form-control"
                          :class="{ 'has-error': errors.has('name') }"
                          placeholder="Name"
                        />
                        <div class="help text-danger" v-show="errors.has('name')">
                          {{ errors.first("name") }}
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="mobile_no" class="control-label">Mobile No.</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text"
                              ><i class="fas fa-phone"></i
                            ></span>
                          </div>
                          <input
                            type="text"
                            id="mobile_no"
                            class="form-control"
                            name="mobile_no"
                            placeholder="Mobile No"
                            :class="{ 'has-error': errors.has('mobile_no') }"
                            v-model="profile.mobile_no"
                          />
                        </div>
                        <div class="help text-danger" v-show="errors.has('mobile_no')">
                          {{ errors.first("mobile_no") }}
                        </div>
                      </div>
                      <div class="form-group required col-md-6">
                        <label for="email" class="control-label">Email</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text"
                              ><i class="fas fa-envelope"></i
                            ></span>
                          </div>
                          <input
                            type="text"
                            id="email"
                            name="email"
                            readonly
                            v-model="profile.email"
                            class="form-control"
                            :class="{ 'has-error': errors.has('email') }"
                            placeholder="Email"
                          />
                        </div>
                        <small class="form-text text-muted">
                          <i class="fa fa-info-circle"></i>&nbsp;We'll never share your
                          email with anyone else.
                        </small>
                        <div class="help text-danger" v-show="errors.has('email')">
                          {{ errors.first("email") }}
                        </div>
                      </div>

                      <div class="form-group required col-md-8">
                        <div class="icheck-primary">
                          <input
                            type="checkbox"
                            v-model.trim="profile.tfa_status"
                            id="tfa_status"
                          />
                          <label for="tfa_status"
                            >Enable Two-Factor Authentication (2FA) for Enhanced
                            Security</label
                          >
                        </div>
                      </div>

                      <div class="col-md-12">
                        <h4 class="site-heading my-3"><span>Avatar</span></h4>
                      </div>
                      <div class="form-group col-md-12">
                        <div class="row align-items-center">
                          <div class="col-md-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="avatar"
                                  class="custom-file-input"
                                  id="avatar"
                                  @change="selectFile"
                                  accept="image/x-png,image/jpg,image/jpeg"
                                />
                                <label class="custom-file-label">Choose file</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-8">
                            <img
                              alt="preview image"
                              v-if="profile.avatar"
                              v-bind:src="profile.avatar"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                          </div>
                          <div class="help text-danger" v-show="errors.has('avatar')">
                            {{ errors.first("avatar") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button type="submit" v-if="!is_edit" class="btn btn-site">
                      Submit
                    </button>
                    <button type="submit" v-if="is_edit" class="btn btn-site">
                      Update
                    </button>
                  </div>
                </form>
              </el-tab-pane>
              <el-tab-pane label="Change Password" name="change_password">
                <form
                  @submit.prevent="handleUpdatePasswordSubmission()"
                  method="POST"
                  novalidate
                >
                  <div>
                    <div class="form-row">
                      <div class="form-group required col-md-12">
                        <label for="old_password" class="control-label"
                          >Old Password</label
                        >
                        <input
                          autocomplete="off"
                          type="password"
                          id="old_password"
                          name="old_password"
                          v-model.trim="changed_pass.old_password"
                          :class="{ 'has-error': errors.has('old_password') }"
                          class="form-control"
                          placeholder="Type Old Password"
                        />
                        <div class="help text-danger" v-show="errors.has('old_password')">
                          {{ errors.first("old_password") }}
                        </div>
                      </div>
                      <div class="form-group required col-md-12">
                        <label for="password" class="control-label">Password</label>
                        <input
                          autocomplete="off"
                          type="password"
                          id="password"
                          name="password"
                          v-validate="'required|PASSWORD_RULE'"
                          v-model="changed_pass.password"
                          :class="{ 'has-error': errors.has('password') }"
                          class="form-control"
                          placeholder="The password must be at least 12 characters long, contain 1 uppercase letter, 1 lowercase letter, and 1 special character."
                        />
                        <div class="help text-danger" v-show="errors.has('password')">
                          {{ errors.first("password") }}
                        </div>
                      </div>
                      <div class="form-group required col-md-12">
                        <label for="password_confirmation" class="control-label"
                          >Confirm Password</label
                        >
                        <input
                          type="password"
                          id="password_confirmation"
                          name="password_confirmation"
                          v-validate="confirmPasswordRule"
                          v-model="changed_pass.password_confirmation"
                          data-vv-validate-on="input"
                          class="form-control"
                          placeholder="The Confirm Password should be the same as New Password."
                        />
                        <div
                          v-show="errors.has('password_confirmation')"
                          class="help text-danger"
                        >
                          {{ errors.first("password_confirmation") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      type="submit"
                      :disabled="isSubmitDisabled"
                      class="btn btn-site"
                    >
                      Update Password
                    </button>
                  </div>
                </form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { AuthAPI } from "@/services/api";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

export default {
  name: "AuthProfile",
  metaInfo: {
    title: "Profile | Dotlines",
  },
  components: {},
  computed: {
    ...mapGetters(["profile"]),
    isSubmitDisabled() {
      return (
        this.changed_pass.password !== this.changed_pass.password_confirmation ||
        this.changed_pass.password.length < 12 ||
        this.changed_pass.password.length > 20
      );
    },

    confirmPasswordRule() {
      return `required|confirm_password:${this.changed_pass.password || ""}`;
    },
  },
  data: () => ({
    is_edit: true,
    changed_pass: {
      password: "",
      password_confirmation: "",
    },
    is_avatar: false,
    isSelectorLoading: false,
    is_loading: false,
    activeTab: "profile",
    passwordRegex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*(),.?":{}|<>~\\-_+=\[\];'/]).{12,}$/,
  }),
  methods: {
    ...mapActions(["FETCH_PROFILE", "LOGOUT"]),
    async logout() {
      await this.LOGOUT();
      localStorage.setItem("authenticate", false);
      localStorage.removeItem("token");
      this.$router.push({ name: "Login" });
    },
    handleProfileSubmission() {
      const _this = this;
      _this.$validator.validateAll("profile").then((result) => {
        if (result) {
          _this.profile.tfa_status = _this.profile.tfa_status ? 1 : 0;
          _this.is_loading = true;
          const api_url = "/admin_users/" + _this.profile.id;
          if (!_this.is_avatar) {
            _this.$delete(_this.profile, "avatar");
          }
          axios({
            method: "PUT",
            url: api_url,
            data: _this.profile,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.errors.clear();
              _this.move({ name: "AuthProfile" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              } else if (errors.response.status === 400) {
                const firstError = Object.values(errors.response.data.errors)[0];
                _this.$toaster.error(firstError);
              } else {
                _this.$toaster.error(errors.response.data.errors.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.FETCH_PROFILE();
              _this.is_avatar = false;
              _this.is_loading = false;
            });
        }
      });
    },
    handleUpdatePasswordSubmission() {
      const _this = this;
      this.$validator.validateAll("passwordtab").then((result) => {
        if (result) {
          this.is_loading = true;
          AuthAPI.changePassword(this.changed_pass)
            .then((response) => {
              this.errors.clear();
              this.$toaster.success(response.message);
              _this.logout();
            })
            .catch((error) => {
              if (error.data && error.data.message) {
                if (error.data.message["old_password"]) {
                  this.$toaster.warning(error.data.message["old_password"][0]);
                } else if (error.data.message["password"]) {
                  this.$toaster.warning(error.data.message["password"][0]);
                }
              }
            })
            .finally(() => {
              this.is_loading = false;
              setTimeout(() => {
                $(".alert").fadeOut("slow");
              }, 5000);
            });
        }
      });
    },
    selectFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.is_avatar = true;
        this.profile.avatar = reader.result;
      };
    },
    move(params) {
      // get comparable fullPaths
      const from = this.$route.fullPath;
      const to = this.$router.resolve(params).route.fullPath;

      if (from === to) {
        // handle any error due the redundant navigation here
        // or handle any other param modification and route afterwards
        return;
      }
      this.$router.push(params);
    },
    handleTabClick() {},
    validatePasswordregex(value) {
      const ipAddressPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*(),.?":{}|<>~\\-_+=\[\];'/]).{12,}$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },
    setCustomValidation: function () {
      const self = this;

      this.$validator.extend("PASSWORD_RULE", {
        getMessage: (field) =>
          "The password must be at least 12 characters long, contain 1 uppercase letter, 1 lowercase letter, and 1 special character.",
        validate: (value) => {
          return self.validatePasswordregex(value) ? 1 : 0;
        },
      });

      this.$validator.extend("confirm_password", {
        getMessage: () => "Password not matched.",
        validate: (value, args) => {
          return value === args[0];
        },
      });
    },
  },
  watch: {
    "changed_pass.password": function () {
      this.$validator.validate("password_confirmation");
    },
    "changed_pass.password_confirmation": function () {
      this.$validator.validate("password_confirmation");
    },
  },
  mounted() {
    this.setCustomValidation();
  },
};
</script>
